import React, { useEffect, useState } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { api, type ProjectDetail } from "../api.js";
import { AppShell } from "../components/AppShell.js";
import { ErrorNote, Spinner } from "../components/ui.js";
import { LaunchExport } from "../launch/LaunchExport.js";
import { Render } from "./Render.js";

/**
 * Export and share, for either kind of project: a product video renders and
 * exports here; a launch film, made on our servers, only downloads and shares.
 */
export const ExportRoute: React.FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const [project, setProject] = useState<ProjectDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [search] = useSearchParams();

  useEffect(() => {
    let current = true;
    setProject(null);
    setError(null);
    api
      .getProject(id)
      .then((detail) => {
        if (current) setProject(detail);
      })
      .catch((cause: unknown) => {
        if (current) setError(cause instanceof Error ? cause.message : "Could not load this project");
      });
    return () => {
      current = false;
    };
  }, [id]);

  // Views was a tab here; it is a page of its own now.
  if (search.get("tab") === "views") return <Navigate to={`/projects/${id}/views`} replace />;
  if (project?.kind === "launch") return <LaunchExport project={project} />;
  if (project) return <Render />;
  return (
    <AppShell>
      {error ? (
        <ErrorNote>{error}</ErrorNote>
      ) : (
        <div className="flex justify-center p-10" role="status" aria-label="Loading">
          <Spinner />
        </div>
      )}
    </AppShell>
  );
};
